import { Avatar, Tab, Tabs } from '@mui/material'
import { ComplianceWizardStep } from '../types'

type StepConfig = {
  step: ComplianceWizardStep
  label: string
}

type WizardNavigationProps = {
  currentStep: ComplianceWizardStep
  onStepChange: (step: ComplianceWizardStep) => void
  canProceedToUsers: boolean
  canProceedToReview: boolean
}

export default function ComplianceWizardNavigation({
  currentStep,
  onStepChange,
  canProceedToUsers,
  canProceedToReview,
}: WizardNavigationProps) {
  let steps: StepConfig[] = [
    { step: 'details', label: 'Details' },
    { step: 'requirements', label: 'Requirements' },
    { step: 'users', label: 'Users' },
    { step: 'review', label: 'Review' },
  ]

  let canProceed = (step: ComplianceWizardStep) => {
    if (step === 'details') return true
    if (step === 'requirements') return canProceedToUsers
    if (step === 'users') return canProceedToUsers
    if (step === 'review') return canProceedToReview
    return false
  }

  return (
    <Tabs value={currentStep} variant="fullWidth">
      {steps.map((tab, i) => (
        <Tab
          key={tab.step}
          value={tab.step}
          label={tab.label}
          onClick={() => onStepChange(tab.step)}
          disabled={!canProceed(tab.step)}
          iconPosition="start"
          icon={
            <Avatar
              sx={{
                width: 24,
                height: 24,
                fontSize: 16,
                color: currentStep === tab.step ? 'white' : 'text.secondary',
                bgcolor:
                  currentStep === tab.step
                    ? 'primary.main'
                    : 'background.paper',
                border: currentStep === tab.step ? 'none' : '2px solid',
                borderColor: 'divider',
              }}
            >
              {i + 1}
            </Avatar>
          }
          sx={{
            gap: 1,
            py: 2,
            textTransform: 'none',
            fontSize: '0.875rem',
            fontWeight: currentStep === tab.step ? 600 : 400,
          }}
        />
      ))}
    </Tabs>
  )
}
